// src/redux/csContractApi.js
import { apiSlice } from "./apiSlice";

export const csContractApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // 1) 약관 동의 완료
        agreeToTerms: build.mutation({
            query: (contractId) => ({
                url: `/api/customer/contract/v1/${contractId}/term_finish`,
                method: "put",
                headers: { token: true },
            }),
        }),

        // 2) 고객 계약서 서명 & 최종 서명 완료
        signContract: build.mutation({
            query: ({ contractId, body }) => ({
                url: `/api/customer/contract/v1/${contractId}/sign`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 3) 전자계약 고객 정보 확인 (이름, 휴대폰 체크)
        checkCustomerInfo: build.mutation({
            query: ({ contractId, body }) => ({
                url: `/api/customer/contract/v1/${contractId}/customer_check`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 4) 계약서 상세조회
        getCustomerContract: build.query({
            query: (contractId) => ({
                url: `/api/customer/contract/v1/${contractId}`,
                method: "get",
                headers: { token: true },
            }),
        }),
    }),
});

export const {
    useAgreeToTermsMutation,
    useSignContractMutation,
    useCheckCustomerInfoMutation,
    useGetCustomerContractQuery,
    useLazyGetCustomerContractQuery,
} = csContractApi;
